import { render, staticRenderFns } from "./videoDetails.vue?vue&type=template&id=062165df&scoped=true&"
import script from "./videoDetails.vue?vue&type=script&lang=js&"
export * from "./videoDetails.vue?vue&type=script&lang=js&"
import style0 from "./videoDetails.vue?vue&type=style&index=0&id=062165df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062165df",
  null
  
)

export default component.exports